<template>
  <div class="box" @keydown="handleKeyDown" @contextmenu.prevent>
    <div class="top-box">
      <div class="user-box">
        <div class="user-img">
          <img :src="this.photograph" width="130px" height="160px" />
        </div>
        <div class="user-info">
          <div>准考证号：{{ this.examRegistrationNumber }}</div>
          <div>考生姓名：{{ this.userName }}</div>
        </div>
      </div>
      <!-- <span>-行政职业能力测试</span> -->
      <div class="title-box">
        <div>{{ examination.testName }}</div>
      </div>
      <div class="time-box">
        <div class="over-time">
          倒计时：{{ pad(hours) }}:{{ pad(remainingMinutes) }}:{{ pad(seconds) }}
        </div>
        <div class="buttons">
          <div @click="submitText">交卷</div>
          <div>使用说明</div>
        </div>
      </div>
    </div>
    <!-- 题目部分 -->
    <div class="center-box">
      <div class="options-box">
        <div class="slide">
          <img src="../../assets/newImg/text_arrow.png" alt="" />
        </div>
        <div class="title">单项选择题</div>
        <div class="topic-item">
          <div
            :class="{ active: item.isOk || `radio-${index}` === currentActive }"
            v-for="(item, index) in radio"
            :key="`radio-${index}`"
            @click="handle(item, `radio-${index}`)"
          >
            {{ index + 1 }}
          </div>
        </div>
        <div class="title">多项选择题</div>
        <div class="topic-item">
          <div
            :class="{ active: item.isOk || `check-${index}` === currentActive }"
            v-for="(item, index) in check"
            :key="`check-${index}`"
            @click="handle(item, `check-${index}`)"
          >
            {{ index + 1 }}
          </div>
        </div>
        <div class="title">判断题</div>
        <div class="topic-item">
          <div
            :class="{ active: item.isOk || `istrue-${index}` === currentActive }"
            v-for="(item, index) in istrue"
            :key="`istrue-${index}`"
            @click="handle(item, `istrue-${index}`)"
          >
            {{ index + 1 }}
          </div>
        </div>
        <div class="title">主观题</div>
        <div class="topic-item">
          <div
            :class="{ active: item.isOk || `textarea-${index}` === currentActive }"
            v-for="(item, index) in textarea"
            :key="`textarea-${index}`"
            @click="handle(item, `textarea-${index}`)"
          >
            {{ index + 1 }}
          </div>
        </div>

        <div class="title">不定项选择题</div>
        <div class="topic-item">
          <div
            :class="{ active: item.isOk || `choiceQuestions-${index}` === currentActive }"
            v-for="(item, index) in choiceQuestions"
            :key="`choiceQuestions-${index}`"
            @click="handle(item, `choiceQuestions-${index}`)"
          >
            {{ index + 1 }}
          </div>
        </div>
      </div>
      <div class="topic-box">
        <!-- 单选 -->
        <template v-for="(item, index) in radio">
          <topic-radio
            ref="paper"
            v-if="currentActive === `radio-${index}`"
            :key="`radio-content-${index}`"
            :RadioNum="index + 1"
            :RadioContent="item.subjectName"
            :redioList="JSON.parse(item.optionConf)"
            :data-id="item.subjectId"
            :currentAnswer="item.currentAnswer"
            @change="handleChange"
          ></topic-radio>
        </template>

        <!-- 多选 -->
        <template v-for="(item, index) in check">
          <topic-check
            ref="paper"
            v-if="currentActive === `check-${index}`"
            :key="`check-content-${index}`"
            :CheckNum="index + 1"
            :CheckContent="item.subjectName"
            :CheckList="JSON.parse(item.optionConf)"
            :data-id="item.subjectId"
            :currentAnswer="item.currentAnswer"
            @change="handleChange"
          ></topic-check>
        </template>
        <!-- 判断 -->
        <template v-for="(item, index) in istrue">
          <topic-true
            ref="paper"
            v-if="currentActive === `istrue-${index}`"
            :key="`istrue-${index}`"
            :TrueNum="index + 1"
            :TrueContent="item.subjectName"
            :TrueList="JSON.parse(item.optionConf)"
            :data-id="item.subjectId"
            :currentAnswer="item.currentAnswer"
            @change="handleChange"
          ></topic-true>
        </template>
        <!-- 主观题 -->
        <template v-for="(item, index) in textarea">
          <topic-textarea
            ref="paper"
            v-if="currentActive === `textarea-${index}`"
            :key="`textarea-${index}`"
            :TextareaNum="index + 1"
            :TextareaContent="item.subjectName"
            :TextareaList="JSON.parse(item.optionConf)"
            :data-id="item.subjectId"
            :currentAnswer="item.currentAnswer"
            @change="handleChange"
          ></topic-textarea>
        </template>
        <!-- 不定项选择题 -->
        <template v-for="(item, index) in choiceQuestions">
          <topic-choiceQuestions
            ref="paper"
            v-if="currentActive === `choiceQuestions-${index}`"
            :key="`choiceQuestions-${index}`"
            :choiceQuestionsNum="index + 1"
            :choiceQuestionsContent="item.subjectName"
            :ChoiceQuestionsList="item.indefiniteSubjectsList"
            :data-id="item.subjectId"
            :currentAnswer="item.currentAnswer"
            @change="handleChoiceChange"
          ></topic-choiceQuestions>
        </template>
      </div>
    </div>
    <!-- 底部操作部分 -->
    <div class="bottom-box">
      <div class="progress-box">
        <div class="bar"></div>
        <div class="slider" :style="{ width: progressPercentage + '%' }"></div>
        <div class="bar-info">答题总进度：{{ isAnswer }} / {{ subjectList.length }}</div>
      </div>
      <div class="buttons">
        <div class="topic" @click="backTopic">上一题</div>
        <div class="topic" @click="nextTopic">下一题</div>
      </div>
      <!-- <div class="buttons">
                <div class="scale">放大</div>
                <div class="scale">缩小</div>

            </div>
             <div class="buttons">
                <div class="revoke">撤销作答</div>
                <div class="markdown">标记本题</div>
            </div> -->
    </div>
  </div>
</template>
<script>
import TopicRadio from "@/components/topicRadio.vue";
import TopicCheck from "@/components/topicCheck.vue";
import TopicTrue from "@/components/topicTrue.vue";
import TopicTextarea from "@/components/topicTextarea.vue";
import TopicChoiceQuestions from "@/components/topicChoiceQuestions.vue";
export default {
  components: {
    TopicRadio,
    TopicCheck,
    TopicTrue,
    TopicTextarea,
    TopicChoiceQuestions,
  },
  data() {
    return {
      currentActive: `radio-0`, //已做未做
      redioList: [], // 单选
      CheckList: [], // 多选
      TrueList: [], // 判断
      TextareaList: [], // 主观
      ChoiceQuestionsList: [], // 不定项
      RadioNum: 1, // 单选
      RadioContent: "", // 单选
      CheckNum: 1, // 多选
      CheckContent: "", // 多选
      TrueNum: 1, // 判断
      TrueContent: "", // 判断
      TextareaNum: 2, // 主观
      TextareaContent: "", // 主观
      choiceQuestionsNum: 1, // 不定项
      choiceQuestionsContent: "", // 不定项
      examId: "",
      examination: {},
      hours: 0,
      remainingMinutes: 0,
      seconds: 0,
      intervalId: null,
      subjectList: [], // 题目个数
      buxxzt: [],
      //   单选题
      radio: [],
      //   多选题
      check: [],
      //   判断
      istrue: [],
      //   主观题
      textarea: [],
      //   不定项选择题
      choiceQuestions: [],
      recordId: "",
      isAnswer: 0,
      userName: "",
      examRegistrationNumber: "",
      photograph: "",
    };
  },
  computed: {
    // 进度条
    progressPercentage() {
      return (this.isAnswer / this.subjectList.length) * 100;
    },
  },
  created() {
    if (this.$route.query.examId) {
      this.examId = this.$route.query.examId;
      this.getExaminationDetail();
      this.getStartExamination();
    }
    this.startCountdown();
    // 查询考试用户信息
    this.selectUser();
  },
  beforeDestroy() {
    this.stopCountdown();
  },
  mounted() {
    document.addEventListener("keydown", this.handleKeyDown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeyDown);
  },
  methods: {
    // 禁止浏览器复制粘贴 在div中是默认不可编辑的区域 把div设置成可编辑区域 就可以 contenteditable
    handleKeyDown(event) {
      if ((event.ctrlKey || event.metaKey) && (event.key === "c" || event.key === "v")) {
        event.preventDefault(); // 阻止默认的复制或粘贴行为
      }
    },
    // 查询考试页面考生信息
    selectUser() {
      this.$api.text.selectUserMessage().then((response) => {
        this.examRegistrationNumber = response.data.examRegistrationNumber;
        this.userName = response.data.name;
        this.photograph = response.data.portrait;
      });
    },
    // 强制提交
    stopText() {
      this.$message({
        message: "考试已结束",
        type: "warning",
      });
      let parmas = {
        recordId: this.recordId,
      };
      this.$api.text.submitExamination(parmas).then((res) => {
        if (res.code == 200 || res.code == 500) {
          this.$message({
            message: "交卷成功",
            type: "success",
          });
          this.$router.push({
            name: "examResult",
            query: { recordId: this.recordId },
          });
        }
      });
    },
    // 交卷
    submitText() {
      const notOk = [];
      this.subjectList.forEach((item) => {
        if (!item.isOk) {
          notOk.push(item);
        }
      });
      if (notOk.length) {
        this.$message({
          message: "仍有题目未完成，不可提交",
          type: "warning",
        });
      } else {
        let parmas = {
          recordId: this.recordId,
        };
        this.$api.text.submitExamination(parmas).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "交卷成功",
              type: "success",
            });
            this.$router.push({
              name: "examResult",
              query: { recordId: this.recordId },
            });
          }
        });
      }
    },
    // 上一题
    backTopic() {
      let arr = this.currentActive.split("-");
      let key = arr[0];
      let index = parseInt(arr[1]);
      index--;
      if (index <= -1) {
        const topicmap = ["radio", "check", "istrue", "textarea", "choiceQuestions"];
        let topindex = topicmap.indexOf(key);
        console.log("上一题：" + topindex);
        if (topindex == 0) {
          this.$message({
            message: "没有上一题了",
            type: "warning",
          });
          return;
        }
        this.currentActive =
          topicmap[topindex - 1] + "-" + (this[topicmap[topindex - 1]].length - 1);
      } else {
        this.currentActive = key + "-" + index;
      }
    },
    // 下一题
    nextTopic() {
      let arr = this.currentActive.split("-");
      let key = arr[0];
      let index = parseInt(arr[1]);
      index++;
      if (this[key].length == index || this[key].length < index) {
        const topicmap = ["radio", "check", "istrue", "textarea", "choiceQuestions"];
        let topindex = topicmap.indexOf(key);
        console.log("下一题：" + topindex);
        if (topindex == 4) {
          this.$message({
            message: "没有下一题了",
            type: "warning",
          });
          return;
        }
        this.currentActive = topicmap[topindex + 1] + "-" + 0;
      } else {
        this.currentActive = key + "-" + index;
      }
    },

    // 选项改变的时候记录答案
    handleChange(data) {
      // 单选 多选 判断 主观
      const objChoiceOne = this.subjectList.find((item) => item.subjectId == data.dataId);
      if (data.answer !== null && data.answer.length > 0) {
        objChoiceOne.isOk = true;
        objChoiceOne.currentAnswer = data.answer;
        this.isAnswer = this.subjectList.filter((item) => item.isOk).length;
        let params = {
          recordId: this.recordId.toString(),
          subjectId: data.dataId.toString(),
          answer: Array.isArray(data.answer) ? data.answer.toString() : data.answer,
          type: "examination",
        };
        this.$api.text.answerProcess(params);
      }
    },
    //不定项选择题
    handleChoiceChange(subjectId, data) {
      const bdx = this.subjectList.find((item) => item.subjectId == subjectId);
      let bsxobj = bdx.indefiniteSubjectsList.find((item) => item.id == data.dataSonId);
      if (data.answer !== null && data.answer.length > 0) {
        this.$set(bsxobj, "isOk", true);
        this.$set(bsxobj, "currentAnswer", data.answer);
        let indefiniteSubjectAnswer = bdx.indefiniteSubjectsList.filter(
          (item) => item.isOk
        ).length;
        if (indefiniteSubjectAnswer == bdx.indefiniteSubjectsList.length) {
          this.subjectList.forEach((item) => {
            if (item.subjectId == subjectId) {
              item.isOk = true;
            }
          });
          this.isAnswer = this.subjectList.filter((item) => item.isOk).length;
        }

        let params = {
          recordId: this.recordId.toString(),
          subjectId: data.dataId.toString(),
          subjectSonId: data.dataSonId.toString(),
          answer: Array.isArray(data.answer) ? data.answer.toString() : data.answer,
          type: "examination",
        };
        this.$api.text.answerProcess(params);
      }
    },

    // 选中样式
    handle(item, key) {
      this.currentActive = key;
    },
    // 倒计时
    startCountdown() {
      this.intervalId = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    },
    // 倒计时结束
    stopCountdown() {
      clearInterval(this.intervalId);
    },
    // 更新倒计时
    updateCountdown() {
      if (this.hours > 0 || this.remainingMinutes > 0 || this.seconds > 0) {
        if (this.remainingMinutes === 0 && this.seconds === 0) {
          this.hours--;
          this.remainingMinutes = 59;
          this.seconds = 59;
        } else if (this.seconds === 0) {
          this.remainingMinutes--;
          this.seconds = 59;
        } else {
          this.seconds--;
        }
      } else {
        this.stopCountdown();
        if (this.hours === 0 && this.remainingMinutes === 0 && this.seconds === 0) {
          this.stopText();
          return "00:00:00";
        }
      }
    },
    // 时分秒转换
    convertMinutesToHHMMSS(minutes) {
      this.hours = Math.floor(minutes / 60);
      this.remainingMinutes = minutes % 60;
      this.seconds = Math.floor((minutes * 60) % 60);

      return this.hours + this.remainingMinutes + this.seconds;
    },
    formatSeconds(value) {
      let secondTime = parseInt(value);
      let minuteTime = 0;
      let hoursTime = 0;
      if (secondTime > 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (minuteTime > 60) {
          hoursTime = parseInt(minuteTime / 60);
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      this.hours = hoursTime;
      this.remainingMinutes = minuteTime;
      this.seconds = secondTime;
    },
    // 时间补0
    pad(value) {
      return value.toString().padStart(2, "0");
    },
    // 获取考试详情
    getExaminationDetail() {
      let _this = this;
      let parmas = {
        examinationId: _this.examId,
      };
      _this.$api.text.getExaminationDetail(parmas).then((res) => {
        if (res.code == 200) {
          _this.examination = res.data;
          _this.convertMinutesToHHMMSS(_this.examination.minute);
        }
      });
    },
    // 获取题目
    getStartExamination() {
      let _this = this;
      let parmas = {
        examinationId: _this.examId,
        type: 2,
      };
      _this.$api.text.getStartExamination(parmas).then((res) => {
        if (res.code == 200) {
          _this.subjectList = res.data.testPaper.subjectItems;
          _this.recordId = res.data.recordId;
          _this.subjectList.forEach(function (item) {
            item.isOk = false; //当前是否已做
            item.isActive = false; //当前是否选中
            if (item.subjectType == 0) {
              _this.radio.push(item);
            } else if (item.subjectType == 1) {
              _this.check.push(item);
            } else if (item.subjectType == 2) {
              _this.istrue.push(item);
            } else if (item.subjectType == 3) {
              _this.textarea.push(item);
            } else if (item.subjectType == 4) {
              _this.choiceQuestions.push(item);
            }
          });

          const userAnswer = res.data.userAnswer;
          if (userAnswer instanceof Array && userAnswer.length > 0) {
            userAnswer.forEach((item) => {
              const obj = _this.subjectList.find(
                (val) => val.subjectId === item.subjectId
              );

              if (item.subjectSonId !== 0 && obj.indefiniteSubjectsList) {
                obj.indefiniteSubjectsList.forEach((subItem) => {
                  if (subItem.id === item.subjectSonId) {
                    subItem.isOk = true;
                    // 将字符串形式的答案转换为数组
                    subItem.currentAnswer = item.answer
                      .split(",")
                      .map((answer) => answer.trim());
                  }
                });
                let indefiniteSubjectAnswer = obj.indefiniteSubjectsList.filter(
                  (item) => item.isOk
                ).length;
                if (indefiniteSubjectAnswer == obj.indefiniteSubjectsList.length) {
                  obj.isOk = true;
                  ++_this.isAnswer;
                }
              } else {
                // 单选、多选、判断或主观题的处理
                obj.isOk = true;
                // obj.currentAnswer = item.answer;
                if (obj.subjectType === 1) {
                  // 多选题
                  obj.currentAnswer = item.answer
                    .split(",")
                    .map((answer) => answer.trim());
                } else {
                  obj.currentAnswer = item.answer;
                }
                ++_this.isAnswer;
              }
            });

            // _this.convertMinutesToHHMMSS(res.data.minute * 60 - Hours * 60 * 60 - Minutes * 60 - Seconds)
          }
          // var startTime = new Date(res.data.startTime);
          // var nowTime = new Date()
          // var Hours = nowTime.getHours() - startTime.getHours();
          // var Minutes = nowTime.getMinutes() - startTime.getMinutes();
          // var Seconds = nowTime.getSeconds() - startTime.getSeconds();
          // this.seconds = res.data.minute * 60 - Hours * 60 * 60 - Minutes * 60 - Seconds;
          this.seconds = res.data.minute * 60;
          _this.formatSeconds(this.seconds);
        }
      });
    },
  },
};
</script>
<style scoped>
.box {
  /* min-height:100%; */
  height: 100vh;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}

.top-box {
  padding: 13px 40px;
  background-color: rgb(64, 112, 179);
  display: flex;
}

.top-box .user-box {
  width: 20%;
  display: flex;
}

.user-box .user-img {
  height: 117.33px;
}

.user-box .user-img img {
  width: 100%;
  height: 100%;
}

.user-box .user-info {
  color: rgb(255, 255, 255);
  font-family: 思源黑体;
  font-size: 20px;
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.top-box .time-box {
  width: 20%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: end;
}

.time-box .over-time {
  color: rgb(255, 255, 255);
  font-family: 思源黑体;
  font-size: 24px;
}

.time-box .buttons {
  display: flex;
}

.time-box .buttons div {
  width: 112px;
  height: 48px;
  border-radius: 8px;
  font-family: 思源黑体;
  font-size: 24px;
  text-align: center;
  cursor: pointer;
}

.time-box .buttons div:nth-child(1) {
  background: rgb(254, 184, 37);
  color: rgb(0, 0, 0);
  line-height: 48px;
  margin-right: 16px;
}

.time-box .buttons div:nth-child(2) {
  border: 2px solid rgb(255, 255, 255);
  color: rgb(255, 255, 255);
  line-height: 45px;
}

.top-box .title-box {
  width: 60%;
  color: rgb(255, 255, 255);
  font-family: 思源黑体;
  font-size: 32rem;
  font-weight: 500;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.top-box .title-box span {
  color: rgb(255, 255, 255);
  font-family: 思源黑体;
  font-size: 24rem;
  font-weight: 400;
}

.center-box {
  display: flex;
  width: 100%;
  overflow-y: auto;
  flex: 1;
}

.center-box .options-box {
  width: 17%;
  background: rgb(242, 249, 255);
  overflow-y: auto;
  /* height: 79vh; */
}

.options-box .slide {
  width: 100%;
  height: 24px;
  display: flex;
  justify-content: flex-end;
  margin: 8px 0px;
}

.options-box .slide img {
  width: 24px;
  height: 100%;
  cursor: pointer;
}

.options-box .title {
  width: 100%;
  height: 56px;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(64, 112, 179);
  border-radius: 8px;
  text-align: center;
  line-height: 56px;
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  font-size: 20px;
}

.options-box .topic-item {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
  padding: 24px 17px;
  box-sizing: border-box;
  gap: 10px;
}

.options-box .topic-item div.active {
  background: rgb(64, 112, 179);
  color: rgb(255, 255, 255);
}

.options-box .topic-item div {
  width: 22%;
  height: 64px;
  box-sizing: border-box;
  cursor: pointer;
  background: rgb(242, 249, 255);
  border: 1px solid rgb(64, 112, 179);
  border-radius: 8px;
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  font-size: 20px;
  text-align: center;
  line-height: 64px;
}

.center-box .topic-box {
  flex: 1;
  padding: 26px 29px;
  overflow-y: auto;
}

.bottom-box {
  width: 100%;
  /* position: absolute;
    bottom: 0; */
  padding: 32px 29px;
  display: flex;
  border-top: 2px solid rgb(164, 171, 189);
  background-color: #fff;
  /* z-index: 99; */
}

.bottom-box .progress-box {
  width: 17%;
  position: relative;
  margin-right: 100px;
}

.bottom-box .progress-box .bar {
  height: 10px;
  background: rgba(61, 82, 102, 0.12);
  opacity: 0.4;
  border-radius: 1px;
}

.bottom-box .progress-box .slider {
  height: 10px;
  background: rgb(64, 112, 179);
  position: absolute;
  top: 0;
}

.bottom-box .progress-box .bar-info {
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  font-size: 20px;
  margin-top: 15px;
  text-align: center;
}

.bottom-box .buttons {
  display: flex;
  margin-right: 56px;
}

.bottom-box .buttons div {
  height: 56px;
  border-radius: 8px;
  font-family: 思源黑体;
  font-size: 20px;
  text-align: center;
  line-height: 56px;
  cursor: pointer;
}

.bottom-box .buttons .topic {
  width: 120px;
  background: rgb(64, 112, 179);
  margin-right: 24px;
  color: rgb(255, 255, 255);
}

.bottom-box .buttons .scale {
  width: 93px;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(0, 0, 0);
  color: rgb(0, 0, 0);
  margin-right: 24px;
}

.bottom-box .buttons .revoke {
  width: 144px;
  background: rgb(218, 90, 82);
  color: rgb(255, 255, 255);
  margin-right: 24px;
}

.bottom-box .buttons .markdown {
  width: 144px;
  background: rgb(25, 195, 134);
  color: rgb(255, 255, 255);
}
</style>



// WEBPACK FOOTER //
// src/view/text/text.vue